import { FC, Fragment } from "react";
import TableColumn from "./types/table-column";
import TableRow from "./types/table-row";
import styles from "styles/UserListing.module.css";
import Spinner from "commons/Spinner/Spinner";
import CustomCssTransition from "commons/CustomCssTransition";

export type TableProps = {
  columns: TableColumn[];
  rows: TableRow[];
  isLoading?: boolean;
  noDataMessage?: string;
};

const TableComponent: FC<TableProps> = (props) => {
  const getTotalColumnsSpan = () => {
    return props.columns.reduce((previous, column) => previous + (column.colSpan ?? 1), 0);
  };

  const totalColumnsSpan = getTotalColumnsSpan();

  return (
    <table className={styles.table_contracts}>
      <thead className={styles.thead}>
        <tr>
          {props.columns.map((column) => {
            return (
              <th key={`column-${column.accessor as string}`} colSpan={column.colSpan} className={styles.th}>
                {column.header}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {props.isLoading ? (
          <tr>
            <td colSpan={totalColumnsSpan}>
              <Spinner isFetched={!props.isLoading} size="80px">
                ""
              </Spinner>
            </td>
          </tr>
        ) : props.rows.length === 0 ? (
          <tr>
            <td colSpan={totalColumnsSpan}>{props.noDataMessage}</td>
          </tr>
        ) : (
          props.rows.map((row) => {
            return (
              <Fragment key={`row-${row.id}`}>
                <tr className={styles.tr} onClick={row.onClick}>
                  {props.columns.map((column) => {
                    return (
                      <td
                        key={`row-${row.id}-column-${column.accessor as string}`}
                        className={styles.td}
                        colSpan={column.colSpan}
                      >
                        {row.value[column.accessor]}
                      </td>
                    );
                  })}
                </tr>
                {row.hiddenComponent && (
                  <CustomCssTransition in={row.isHiddenComponentVisible ?? true} trMode colSpan={totalColumnsSpan}>
                    {row.hiddenComponent}
                  </CustomCssTransition>
                )}
              </Fragment>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export default TableComponent;
